import { render, staticRenderFns } from "./adesione.vue?vue&type=template&id=e3cc81fa&scoped=true&"
import script from "./adesione.vue.ts?vue&type=script&lang=ts&"
export * from "./adesione.vue.ts?vue&type=script&lang=ts&"
import style0 from "./adesione.vue?vue&type=style&index=0&id=e3cc81fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cc81fa",
  null
  
)

export default component.exports